import { ApiParams, ParamValue } from "app/backend/apiParams";
import { ApiAggregationType, ApiHistogramType, ApiReport, ApiReportType } from "app/backend/types";
import { Ajax } from "app/utils/ajax";
import { TimeConfig } from "app/utils/timeUtils";

enum MediaAnalyticsUrlEnum {
  MAIN = "https://media-analytics.cqloud.com",
}

export enum AnalyticsReportTypeEnum {
  AGGREGATION = "aggregation",
  HISTOGRAM = "histogram",
}

export enum AnalyticsSeriesEnum {
  QOE_SERVED_BITRATE = "servedBitrate",
  // From Qwilt
  BANDWIDTH_BY_QWILT = "l2BwLocalDelivery",
  VOLUME_SERVED_PER_SITE = "l7VideoLocalDeliveryPerSite5Min",
  VOLUME_SERVED_QWILT = "l2LocalDelivery",
  // From origin
  VOLUME_ORIGIN_PER_SITE = "l7VideoByContentProviderPerSite5Min",
  // HTTP response
  TPS_200_DELIVERY_PER_SITE = "transactionsPerSecond2xxDeliveryPerSite",
  TPS_300_DELIVERY_PER_SITE = "transactionsPerSecond3xxDeliveryPerSite",
  TPS_400_DELIVERY_PER_SITE = "transactionsPerSecond4xxDeliveryPerSite",
  TPS_500_DELIVERY_PER_SITE = "transactionsPerSecond5xxDeliveryPerSite",
  // Transactions
  TPS_ORIGIN_PER_SITE = "transactionsPerSecondOriginPerSite",
  TPS_DELIVERY_PER_SITE = "transactionsPerSecondDeliveryPerSite",
}

export enum AnalyticsParamsEnum {
  BIN_INTERVAL = "bin_interval",
  SERIES = "series",
  GROUP_BY = "group_by",
  SYSTEM_IDS = "systems",
  GEO_IDS = "geos",
  FROM_DATE = "from",
  TO_DATE = "to",
  DEBUG = "debug",
  SITES = "sites",
  ISP = "isps",
  TOTALS = "totals",
}

export type AnalyticsParams = { [param in AnalyticsParamsEnum]?: ParamValue };

export class MediaAnalyticsApi {
  private readonly originUrl = MediaAnalyticsUrlEnum.MAIN;

  getReport = async (
    reportType: AnalyticsReportTypeEnum,
    timeConfig: TimeConfig,
    additionalParams?: AnalyticsParams
  ): Promise<ApiReportType> => {
    const path = `api/1.0/reports/overtime/${reportType}`;
    const params = new ApiParams({
      from: Math.floor(timeConfig.fromDate / 1000),
      to: Math.floor(timeConfig.toDate / 1000),
      debug: true,
      ...additionalParams,
    });

    const url = new URL(`${this.originUrl}/${path}/${params.stringified}`);

    return await Ajax.getJson(url.href);
  };

  getHistogram = async (timeConfig: TimeConfig, series: AnalyticsSeriesEnum[], additionalParams?: AnalyticsParams) => {
    const params: AnalyticsParams = {
      series,
      bin_interval: `${timeConfig.interval.seconds}s`,
      geos: "geo_6295630", // world-wide
      ...additionalParams,
    };
    return this.getReport(AnalyticsReportTypeEnum.HISTOGRAM, timeConfig, params) as Promise<
      ApiReport<ApiHistogramType>
    >;
  };

  getAggregation = async (timeConfig: TimeConfig, series: AnalyticsSeriesEnum[], additionalParams: AnalyticsParams) => {
    const params: AnalyticsParams = {
      series,
      systems: "unused-param",
      ...additionalParams,
    };

    return this.getReport(AnalyticsReportTypeEnum.AGGREGATION, timeConfig, params) as Promise<
      ApiReport<ApiAggregationType>
    >;
  };
}



// WEBPACK FOOTER //
// ./app/backend/mediaAnalyticsApi.ts